import { Button, Flex, Table, Tooltip } from "antd";
import { ColumnType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import TimesheetSummaryHeader from "../containers/TimesheetSummaryHeader";
import TimewritingCalendar from "../containers/TimewritingCalendar";
import { useTimewriting } from "../contexts/TimewritingContext";
import { GetAntIcon } from "../utils/ant_icons";
import ExportReportButton from "./Button/Timewriting.tsx/ExportReportButton";
import SearchButton from "./SearchButton";
import WeekNavigator from "./WeekNavigator";
// import { includesIgnoreCase } from "../utils/utils";
interface ProjectSummaryTableData {
	project_name: string;
	client_name: string;
	logged_hours: number;
	submitted_timesheet: number;
	pending_review: number;
	approved: number;
	rejected: number;
}

function TimesheetWeekNavigationHeader({
	project,
	data,
	openCalendar,
	setOpenCalendar,
	children,
}: {
	project: any;
	data: any[];
	openCalendar: boolean;
	setOpenCalendar: (openCalendar: boolean) => void;
	children?: React.ReactNode;
}) {
	// const extractProjectUsers = (projectData: any, data: any) => {
	// 	const role_users_dict: any = {};

	// 	const submittedTimesheetUsers = data.map((element: any) => {
	// 		return element.user;
	// 	});

	// 	// fetch submitted timesheet for that month

	// 	// Get all users that has submitted timesheet in that month

	// 	const project_manager =
	// 		projectData.project_manager?.map((email: string) => email) || []; // Filter out matching users from project_manager
	// 	if (project_manager.length > 0) {
	// 		role_users_dict["Project Manager"] = project_manager;
	// 	}

	// 	// add role assignments to role_users_dict
	// 	projectData.role_assignments.filter((_role: any) => {
	// 		submittedTimesheetUsers.map((user: string) => {
	// 			if (includesIgnoreCase(_role.appointee, user)) {
	// 				if (!role_users_dict[_role.role]) {
	// 					role_users_dict[_role.role] = [];
	// 				}
	// 				role_users_dict[_role.role].push(user);
	// 			}
	// 		});
	// 	});
	// 	projectData.role_assignments.forEach((_role: any) => {
	// 		const user = _role.appointee;
	// 		const role = _role.role;

	// 		role_users_dict[role] = user;
	// 	});

	// 	const general_members =
	// 		projectData.general_members?.map((user: string) => user) || []; // Filter out matching users from general_members
	// 	if (general_members.length > 0) {
	// 		role_users_dict["General Member"] = general_members;
	// 	}

	// 	console.log("role_users_dict", role_users_dict);
	// 	return role_users_dict;
	// };

	return (
		<>
			<div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
				{openCalendar && (
					<Button type="link" onClick={() => setOpenCalendar(false)}>
						{GetAntIcon("leftarrow")}Back
					</Button>
				)}
				{children}
			</div>
			<Flex align="center" gap={12} justify="flex-end">
				<strong>{project.project_name}</strong>
				<span className="timesheet-summary-header-divider">|</span>
				<TimesheetSummaryHeader
					data={data}
					project_id={project._id}
					customWeekLabel={"Total submitted hours (Week)"}
					customMonthLabel={"Total submitted hours (Month)"}
				/>
				<ExportReportButton
					openCalendar={openCalendar}
					activeProject={project}
				/>
			</Flex>
		</>
	);
}

function ProjectSummaryTable() {
	const {
		weeklyProjectSummary,
		allUserWeekSubmittedReview,
		timesheetManagementData,
	} = useTimewriting();

	const [openCalendar, setOpenCalendar] = useState<boolean>(false);
	const [userTimeEntries, setUserTimeEntries] = useState<any[]>([]);
	const [activeProject, setActiveProject] = useState<any>(null);
	const [filteredProjectSummaryData, setFilteredProjectSummaryData] = useState<
		any[] | null
	>(null);

	const handleSearch = (e: any) => {
		if (e.value === "") {
			setFilteredProjectSummaryData(null);
			return;
		} else {
			const filteredData = weeklyProjectSummary.filter((item: any) =>
				item[e.columnKey]?.toLowerCase().includes(e.value.toLowerCase())
			);
			setFilteredProjectSummaryData(filteredData);
		}
	};

	const columns: ColumnType<ProjectSummaryTableData>[] = [
		{
			title: (
				<div className="timesheet-search-button">
					<SearchButton
						handleSearch={handleSearch}
						headerName="Project name"
						columnKey="project_name"
						searchBarType="panel"
					/>
				</div>
			),
			dataIndex: "project_name",
			key: "project_name",
			width: "15%",
			render: (text: string, record: any) => {
				return (
					<div>
						<div>{text}</div>
						<Flex
							justify="start"
							gap={8}
							style={{ fontSize: "12px", color: "grey" }}
						>
							<Tooltip title={record.tenant_name}>
								<div
									style={{
										width: "108px",
										whiteSpace: "nowrap",
										overflow: "hidden",
										textOverflow: "ellipsis",
									}}
								>
									{GetAntIcon("apartment")} {record.tenant_name}
								</div>
							</Tooltip>
							<Tooltip title={record.client_name}>
								<div
									style={{
										width: "108px",
										whiteSpace: "nowrap",
										overflow: "hidden",
										textOverflow: "ellipsis",
									}}
								>
									{GetAntIcon("profile")} {record.client_name}
								</div>
							</Tooltip>
						</Flex>
					</div>
				);
			},
		},
		{
			title: (
				<div className="timesheet-search-button">
					<SearchButton
						handleSearch={handleSearch}
						headerName="Client name"
						columnKey="client_name"
						searchBarType="panel"
					/>
				</div>
			),
			dataIndex: "client_name",
			key: "client_name",
			width: "15%",
		},
		{
			title: "No. of members",
			key: "total_members",
			width: 200,
			render: (_: any, record: any) => {
				const members = [
					...(record.general_members ?? []),
					...(record.project_manager ?? []),
					...(record.role_assignments.flatMap((role: any) => role.appointee) ??
						[]),
				];
				return Array.from(new Set([...members])).length;
			},
			sorter: (a: any, b: any) => {
				const countMembers = (item: any) => {
					const members = [
						...(item.general_members ?? []),
						...(item.project_manager ?? []),
						...(item.role_assignments.flatMap((role: any) => role.appointee) ??
							[]),
					];
					return Array.from(new Set([...members])).length;
				};
				return countMembers(a) - countMembers(b);
			},
		},
		{
			title: "Total logged hours",
			dataIndex: "logged_hours",
			key: "logged_hours",
			width: 200,
			render: (_: any, record: any) => {
				const loggedHours = record.time_entries.reduce(
					(acc: any, entry: any) => {
						return acc + (entry.duration_hours * 60 + entry.duration_mins);
					},
					0
				);
				const hours = Math.floor(loggedHours / 60);
				const minutes = loggedHours % 60;
				if (isNaN(hours) && isNaN(minutes)) {
					return "-";
				}
				return `${isNaN(hours) ? 0 : hours}h ${isNaN(minutes) ? 0 : minutes}m`;
			},
			sorter: (a: any, b: any) => {
				const getLoggedMinutes = (record: any) =>
					record.time_entries.reduce(
						(acc: any, entry: any) =>
							acc + (entry.duration_hours * 60 + entry.duration_mins),
						0
					);
				return getLoggedMinutes(a) - getLoggedMinutes(b);
			},
		},
		{
			title: "Submitted timesheet",
			dataIndex: "submitted_timesheet",
			key: "submitted_timesheet",
			width: 200,
			render: (_: any, record: any) => {
				return (
					record.time_entries.filter((entry: any) =>
						["submitted", "resubmitted", "approved", "rejected"].includes(
							entry.status
						)
					).length || "-"
				);
			},
			sorter: (a: any, b: any) => {
				const countSubmitted = (record: any) =>
					record.time_entries.filter((entry: any) =>
						["submitted", "resubmitted", "approved", "rejected"].includes(
							entry.status
						)
					).length;

				return countSubmitted(a) - countSubmitted(b);
			},
		},
		{
			title: "Pending review",
			dataIndex: "pending_review",
			key: "pending_review",
			width: 200,
			render: (_: any, record: any) => {
				return (
					record.time_entries.filter(
						(entry: any) =>
							entry.status === "submitted" || entry.status === "resubmitted"
					).length || "-"
				);
			},
			sorter: (a: any, b: any) => {
				const countPending = (record: any) =>
					record.time_entries.filter((entry: any) =>
						["submitted", "resubmitted"].includes(entry.status)
					).length;

				return countPending(a) - countPending(b);
			},
		},
		{
			title: "Approved",
			dataIndex: "approved",
			key: "approved",
			width: 200,
			render: (_: any, record: any) => {
				return (
					record.time_entries.filter(
						(entry: any) => entry.status === "approved"
					).length || "-"
				);
			},
			sorter: (a: any, b: any) => {
				const countApproved = (record: any) =>
					record.time_entries.filter(
						(entry: any) => entry.status === "approved"
					).length;
				return countApproved(a) - countApproved(b);
			},
		},
		{
			title: "Rejected",
			dataIndex: "rejected",
			key: "rejected",
			width: 200,
			render: (_: any, record: any) => {
				return (
					record.time_entries.filter(
						(entry: any) => entry.status === "rejected"
					).length || "-"
				);
			},
			sorter: (a: any, b: any) => {
				const countRejected = (record: any) =>
					record.time_entries.filter(
						(entry: any) => entry.status === "rejected"
					).length;
				return countRejected(a) - countRejected(b);
			},
		},
	];

	const getUserCalendarClassName = (cell: any) => {
		const userSubmittedReview = allUserWeekSubmittedReview.find(
			(submitted_review: any) => submitted_review.user === cell.user
		);
		const projectSubmission = userSubmittedReview?.submissions.find(
			(submission: any) => submission.project_id === activeProject._id
		);
		const status = projectSubmission?.status;
		console.log("debug status", status);
		if (status === "rejected") return "cell-rejected cell-submitted";
		if (status === "approved") return "cell-approved cell-submitted";
		return "";
	};

	const sortUserTimeEntries = (entries: any[]) => {
		return entries.sort((a: any, b: any) => {
			// sort by the following order: "submitted"/"resubmitted", "rejected", "approved"
			// then followed by the time of submission
			const statusA = a.review_status;
			const statusB = b.review_status;

			// Define priority order for statuses
			const statusPriority: { [key: string]: number } = {
				submitted: 0,
				resubmitted: 0,
				rejected: 1,
				approved: 2,
			};

			// Handle cases where status might be undefined
			const priorityA = statusA ? statusPriority[statusA] : -1;
			const priorityB = statusB ? statusPriority[statusB] : -1;

			// Sort by priority
			if (priorityA !== priorityB) {
				return priorityA - priorityB;
			}

			// If same status, sort by submission time
			const timeA = a.submission_time
				? new Date(a.submission_time).getTime()
				: 0;
			const timeB = b.submission_time
				? new Date(b.submission_time).getTime()
				: 0;
			return timeA - timeB; // Older first
		});
	};

	useEffect(() => {
		// Build user entries based on submitted reviews for the active project,
		// then enrich with time entry data from timesheetManagementData.
		// This ensures users who have submitted a review but have no time entries
		// in timesheetManagementData are still included.
		if (activeProject) {
			const entries = allUserWeekSubmittedReview
				.filter((submitted_review: any) =>
					submitted_review.submissions.some(
						(submission: any) => submission.project_id === activeProject._id
					)
				)
				.map((submitted_review: any) => {
					const projectSubmission = submitted_review.submissions.find(
						(submission: any) => submission.project_id === activeProject._id
					);

					const userTimesheetData = timesheetManagementData.find(
						(item: any) => item.user === submitted_review.user
					);

					const time_entries = userTimesheetData
						? userTimesheetData.time_entries.filter(
								(entry: any) => entry.project_id === activeProject._id
							)
						: [];

					return {
						user: submitted_review.user,
						time_entries,
						review_status: projectSubmission?.status,
						submission_time: projectSubmission?.history[0]?.submitted_date,
					};
				});

			const sortedEntries = sortUserTimeEntries(entries);
			setUserTimeEntries(sortedEntries);
		}
	}, [timesheetManagementData, activeProject, allUserWeekSubmittedReview]);

	// useEffect(() => {
	// 	console.log("MTEST: timesheetManagementData: ", timesheetManagementData);
	// }, [timesheetManagementData]);

	// useEffect(() => {
	// 	console.log(
	// 		"MTEST: allUserWeekSubmittedReview: ",
	// 		allUserWeekSubmittedReview
	// 	);
	// }, [allUserWeekSubmittedReview]);

	// useEffect(() => {
	// 	console.log("MTEST: userTimeEntries: ", userTimeEntries);
	// }, [userTimeEntries]);

	const handleRowClick = async (record: any) => {
		setOpenCalendar(true);
		setActiveProject(record);
		// getUserTimeEntryFromProject will be called via useEffect when activeProject changes
	};

	return (
		<>
			{openCalendar ? (
				<TimewritingCalendar
					project={activeProject}
					data={userTimeEntries}
					headerComponent={
						<TimesheetWeekNavigationHeader
							project={activeProject}
							data={userTimeEntries}
							openCalendar={openCalendar}
							setOpenCalendar={setOpenCalendar}
						/>
					}
					type="user"
					cellClassName={(cell) => getUserCalendarClassName(cell)}
				/>
			) : (
				<>
					<div className="week-navigator">
						<WeekNavigator />
						<ExportReportButton />
					</div>
					<Table
						style={{ overflow: "auto" }}
						onRow={(record) => {
							return {
								onClick: () => handleRowClick(record),
							};
						}}
						rootClassName="timesheet-management-table"
						columns={columns}
						dataSource={filteredProjectSummaryData ?? weeklyProjectSummary}
						pagination={false}
						bordered
					/>
				</>
			)}
		</>
	);
}

export default ProjectSummaryTable;
